<script setup>
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: null,
    },
    checked: {
        default: false,
        validator(value) {
            return [true, false, -1].includes(value)
        }
    },
    checkboxClass: {
        type: String,
    },
    design: {
        type: String,
        default: 'primary',
        validator(value) {
            return ['primary', 'secondary'].includes(value)
        }
    }
})

// Computed for checked status, prioritizing modelValue if provided.
const checked = computed(() => props.modelValue ?? props.checked)

const emit = defineEmits(['update:modelValue'])
const toggle = () => {
    if (props.modelValue !== null) {
        emit('update:modelValue', !props.modelValue)
    }
}

// Computed for dynamic class based on design and checked state
const checkboxClasses = computed(() => ({
    'text-[#7F56D9] border-[#D0D5DD]': props.design === 'primary',
    'text-white p-[3px] border-[#7F56D9]': props.design === 'secondary',
    '!border-[#7F56D9] bg-[#F9F5FF]': checked.value && props.design === 'primary',
    'bg-[#7F56D9]': checked.value && props.design === 'secondary',
    [props.checkboxClass]: props.checkboxClass,
}))
</script>

<template>
    <div class="inline-flex items-center gap-3 cursor-pointer w-fit" tabindex="-1" @click="toggle">
        <div>
            <div class="flex items-center justify-center w-5 h-5 rounded-md border" :class="checkboxClasses">
                <svg v-if="checked === true" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.6666 1.5L4.24998 7.91667L1.33331 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg v-if="checked === -1" width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.91669 1H10.0834" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
        </div>
        <slot></slot>
    </div>
</template>
